import { useRef, useEffect, Fragment } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import useLineLiff from 'hooks/LineLiff';

const LexusServiceNews = () => {
  const { liff, userInfo } = useLineLiff(
    process.env.REACT_APP_LIFF_ID_SERVICE_NEWS
  );

  useEffect(() => {
    const processValidation = async () => {
      try {
        window.location.href = process.env.REACT_APP_LEXUS_URL;
      } catch (error) {
        console.error('Error sending reurl tag:', error);
      }
    };

    processValidation();
  }, [liff, userInfo]);

  return <div></div>;
};

export default LexusServiceNews;
